<template>
  <div class="landing-page">
    <!-- Animated Stars Background -->
    <div class="stars-container">
      <div v-for="n in 60" :key="n" class="star" :style="getStarStyle()"></div>
    </div>

    <!-- Side Decorations -->
    <div class="side-decoration left">
      <div class="deco-star" style="top: 15%; left: 20%;">✦</div>
      <div class="deco-star small" style="top: 25%; left: 40%;">•</div>
      <div class="deco-star" style="top: 40%; left: 10%;">✦</div>
      <div class="deco-star small" style="top: 55%; left: 35%;">•</div>
      <div class="deco-star" style="top: 70%; left: 25%;">✦</div>
      <div class="deco-star small" style="top: 85%; left: 15%;">•</div>
    </div>
    <div class="side-decoration right">
      <div class="deco-star" style="top: 20%; right: 15%;">✦</div>
      <div class="deco-star small" style="top: 30%; right: 35%;">•</div>
      <div class="deco-star" style="top: 45%; right: 20%;">✦</div>
      <div class="deco-star small" style="top: 60%; right: 40%;">•</div>
      <div class="deco-star" style="top: 75%; right: 10%;">✦</div>
      <div class="deco-star small" style="top: 90%; right: 30%;">•</div>
    </div>

    <!-- Navigation -->
    <nav class="navbar">
      <img src="@/assets/astroway-icon.png" alt="Astro Way" class="nav-logo" />
    </nav>

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-badge">
        <span class="badge-star">✦</span>
        AI-Powered Astrology
      </div>
      <h1 class="hero-title">
        Discover Your<br/>
        <span class="gradient-text">Cosmic Journey</span>
      </h1>
      <p class="hero-subtitle">
        Personalized astrology readings powered by AI. Get daily insights,
        birth chart analysis, and guidance for love, career, and life.
      </p>

      <!-- Real App Store Badge -->
      <a :href="appStoreUrl" class="app-store-badge" target="_blank" rel="noopener noreferrer">
        <img
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1234567890"
          alt="Download on the App Store"
        />
      </a>

      <!-- Rating -->
      <div class="rating-info">
        <div class="stars-rating">
          <span v-for="n in 5" :key="n" class="rating-star">★</span>
        </div>
        <span class="rating-text">4.8 Rating on App Store</span>
      </div>
    </section>

    <!-- App banner slot (banner.js bu div'in içine inject eder) -->
    <div class="app-banner-slot"></div>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      appStoreUrl: 'https://apps.apple.com/us/app/astro-way-personal-astrology/id6745006379'
    }
  },
  methods: {
    getStarStyle() {
      const random = (min, max) => Math.random() * (max - min) + min;
      return {
        left: `${random(0, 100)}%`,
        top: `${random(0, 100)}%`,
        width: `${random(1, 3)}px`,
        height: `${random(1, 3)}px`,
        animationDelay: `${random(0, 5)}s`,
        animationDuration: `${random(2, 5)}s`
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-banner-slot {
  position: fixed;
  top: 16px;
  left: 116px;
  width: 820px;
  height: 180px;
  z-index: 9999;
}

.landing-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: radial-gradient(ellipse at center, #1B154B 0%, #0E0C1F 70%);
  color: #ffffff;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 10;
}

/* Animated Stars Background */
.stars-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.star {
  position: absolute;
  background: #ffffff;
  border-radius: 50%;
  animation: twinkle 3s ease-in-out infinite;
  opacity: 0.6;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

/* Side Decorations */
.side-decoration {
  position: fixed;
  top: 0;
  width: 200px;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.side-decoration.left {
  left: 0;
}

.side-decoration.right {
  right: 0;
}

.deco-star {
  position: absolute;
  color: rgba(219, 192, 135, 0.4);
  font-size: 16px;
  animation: floatStar 6s ease-in-out infinite;
}

.deco-star.small {
  font-size: 8px;
  color: rgba(255, 255, 255, 0.3);
}

@keyframes floatStar {
  0%, 100% { transform: translateY(0); opacity: 0.4; }
  50% { transform: translateY(-10px); opacity: 0.8; }
}

/* Navigation */
.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 40px;
  position: relative;
  z-index: 10;
  max-width: 1200px;
  margin: 0 auto;
}

.nav-logo {
  height: 32px;
  width: auto;
  object-fit: contain;
}

/* Hero Section */
.hero {
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 40px 100px;
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 80px);
  justify-content: center;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(219, 192, 135, 0.1);
  border: 1px solid rgba(219, 192, 135, 0.25);
  padding: 10px 24px;
  border-radius: 100px;
  font-size: 14px;
  color: #DBC087;
  margin-bottom: 32px;
}

.badge-star {
  font-size: 14px;
}

.hero-title {
  font-size: 64px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 24px;
  color: #ffffff;
}

.gradient-text {
  background: linear-gradient(270deg, #DBC087 0%, #AB8D60 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 18px;
  line-height: 1.7;
  color: #9896a8;
  margin-bottom: 40px;
  max-width: 550px;
}

/* App Store Badge */
.app-store-badge {
  display: inline-block;
  margin-bottom: 28px;
  transition: all 0.3s ease;
}

.app-store-badge:hover {
  transform: translateY(-3px);
  filter: brightness(1.1);
}

.app-store-badge img {
  height: 52px;
  width: auto;
}

/* Rating */
.rating-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.stars-rating {
  display: flex;
  gap: 3px;
}

.rating-star {
  color: #DBC087;
  font-size: 16px;
}

.rating-text {
  color: #9896a8;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 52px;
  }

  .side-decoration {
    width: 120px;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 20px;
  }

  .nav-logo {
    height: 28px;
  }

  .hero {
    padding: 40px 20px 60px;
  }

  .hero-title {
    font-size: 40px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .side-decoration {
    display: none;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 34px;
  }

  .hero-subtitle {
    font-size: 15px;
  }

  .app-store-badge img {
    height: 46px;
  }
}
</style>
